module.exports = __webpack_public_path__ + "static/assets/7da80fd2a6c02b8ed30ba73c91733e1d.png";